import React, { useEffect, useRef, useState } from 'react';
import { PropertyObj } from '../../../Models/PropertyObj';

// Types
type Tab = {
  id: string;
  title: string;
  subtitle: string;
  icon: string;
  accept?: string;
  type: "file" | "url";
};

const TABS: Tab[] = [{
  id: 'tours3d',
  title: '3D Tour',
  subtitle: 'Enter a URL to your 360° virtual tour.',
  icon: 'fa-eye',
  type: 'url'
},
{
  id: 'videos',
  title: 'Video',
  subtitle: 'Enter a video URL.',
  icon: 'fa-video',
  type: 'url'
}
];
const MediaUploadSection: React.FunctionComponent<{ property: any, onchangeProperty: any }> = (props) => {
  const [activeTab, setActiveTab] = useState<string>('tours3d');
  const [property, setProperty] = useState<PropertyObj>(props.property ? props.property : {});
  const [tour3DError, setTour3DError] = useState<boolean>(false);
  const [videoError, setVideoError] = useState<boolean>(false);

  useEffect(() => {
    props.onchangeProperty(property)
  }, [property])


  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setProperty((prev: any) => ({ ...prev, [name]: value }));
  };

  const isValidUrl = (url: string): boolean => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
      return false;
    }
  };

  return (
    <div className="row card-form mb-4">
      {/* Tabs */}
      <div className="row d-flex justify-content-center align-items-center mt-2 mb-4">
        <div className="tabs padd-10">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              className={`tab color-08 title-onest-18 para-16-mb cursor-p flex items-center ${activeTab === tab.id ? "tab-active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={`fas ${tab.icon} me-2`} />
              <span>{tab.title}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="border-CBD5E1 padd-2-4 border-20">
        {activeTab === "tours3d" && (
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-8 ">
              <input
                type="text"
                className="form-input mb-4"
                name="view360"
                placeholder="Paste your 3D tour URL"
                value={property.view360 || ''}
                onChange={(e) => {
                  handleChange(e);
                  setTour3DError(false);
                }}
              />
            </div>
            <div className="col-md-8">
              {property.view360 && (
                <>
                  {isValidUrl(property.view360 || '') ? (
                    <div className="ratio ratio-16x9">
                      <iframe
                        src={property.view360 || ''}
                        frameBorder="0"
                        allowFullScreen
                        onError={() => setTour3DError(true)}
                      />
                    </div>
                  ) : (
                    <div className="alert alert-danger mt-3">
                      🚨 Invalid or inaccessible 3D Tour link.
                    </div>
                  )}
                </>
              )}

            </div>
          </div>
        )}

        {activeTab === "videos" && (
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-8">
              <input
                type="text"
                className="form-input mb-4"
                name="videoTourUrl"
                placeholder="Paste your video URL"
                value={property.videoTourUrl || ''}
                onChange={(e) => {
                  handleChange(e);
                  setVideoError(false);
                }}
              />
            </div>
            <div className="col-md-8">
              {property.videoTourUrl && !videoError && (
                <div className="ratio ratio-16x9">
                  <video
                    src={property.videoTourUrl || ''}
                    controls
                    className="w-100"
                    onError={() => setVideoError(true)}
                  />
                </div>
              )}
              {videoError && (
                <div className="alert alert-danger mt-3">
                  🚨 Invalid or unsupported video link.
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MediaUploadSection;
